import React from 'react';
import { TextField, Typography, Box } from '@mui/material';
import { ExperienceFieldProps } from '../../types/profileForm.types';

const ExperienceField: React.FC<ExperienceFieldProps> = ({
  label,
  value,
  error,
  onChange,
  onBlur,
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = event.target.value;
    
    // Allow empty string for clearing the field
    if (inputValue === '') {
      onChange(0);
      return;
    }
    
    // Parse and validate numeric input
    const numericValue = parseInt(inputValue, 10);
    
    // Only update if it's a valid number within range
    if (!isNaN(numericValue) && numericValue >= 0 && numericValue <= 50) {
      onChange(numericValue);
    }
  };

  const handleBlur = () => {
    onBlur();
  };

  return (
    <Box sx={{ mb: 1, display: 'flex', alignItems: 'center' }}>
      <Typography
        variant="subtitle1"
        sx={{
          minWidth: { xs: '80px', sm: '120px' },
          flexShrink: 0,
          fontSize: '14px',
          fontWeight: 600,
          color: '#212529',
        }}
      >
        {label}
      </Typography>

      <Box sx={{ flex: 1, ml: 8 }}>
        <TextField
          type="number"
          value={value || ''}
          onChange={handleChange}
          onBlur={handleBlur}
          placeholder="0"
          error={!!error}
          helperText={error}
          fullWidth
          inputProps={{
            min: 0,
            max: 50,
            step: 1,
          }}
          sx={{
            '& .MuiOutlinedInput-root': {
              height: '48px',
              borderRadius: '8px',
              fontSize: '16px',
              backgroundColor: '#fff',
              '& fieldset': {
                borderColor: error ? '#dc3545' : '#dee2e6',
                borderWidth: '1px',
              },
              '&:hover fieldset': {
                borderColor: error ? '#dc3545' : '#007bff',
              },
              '&.Mui-focused fieldset': {
                borderColor: error ? '#dc3545' : '#007bff',
                borderWidth: '2px',
              },
              '& input': {
                padding: '12px 16px',
                fontSize: '16px',
              },
            },
            '& .MuiFormHelperText-root': {
              fontSize: '12px',
              color: '#dc3545',
              marginLeft: 0,
              marginTop: '4px',
            },
          }}
        />
      </Box>
    </Box>
  );
};

export default ExperienceField;